<template>
  <div>
    <div class="form_wrap">
      <img src="@/assets/img/pic_banner.png" alt v-if="isEdit" />
      <div class="nav_pos mb_nav_pos" style="border-bottom: 1px solid #dbdbdb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/">首页</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>供应商信息编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <span class="title">公司信息</span>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm1">
          <div class="form_left">
            <el-form-item label="姓名：" prop="Contact" label-width="150px">
              <el-input v-model="ruleForm.Contact" placeholder="请填写您的真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别：" prop="Sex" label-width="150px">
              <el-select v-model="ruleForm.Sex" placeholder="请选择" class="width_full">
                <el-option label="男" :value="false"></el-option>
                <el-option label="女" :value="true"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件类型：" prop="CertificateType" label-width="150px" ref="CertificateType">
              <el-select v-model="ruleForm.CertificateType" placeholder="请选择" class="width_full" @change="CertificateTypeFn">
                <el-option v-for="item in ruleForm.CertificateTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="引入来源：" prop="IntroductionSource" label-width="150px">
              内部员工推荐
              <el-select v-model="ruleForm.IntroductionSource" class="width_full" placeholder="请选择">
                <el-option :key="item.value" label=""
                  value="0"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="供应商类型：" label-width="150px" prop="SupplierType">
              <div>
                <div><el-button icon="el-icon-search" @click.stop="openSupplierTypePage">选择供应商类型</el-button></div>
                <div v-for="(item, index) in ruleForm.SupplierTypeName" :key="index">{{ item }}</div>
              </div>
            </el-form-item>
            <el-form-item label="关联公司：" label-width="150px" prop="SupplierRelatedCompany">
              <el-select v-model="ruleForm.SupplierRelatedCompany" class="width_full" :multiple="true">
                <el-option
                  :label="item.text"
                  :value="item.value"
                  v-for="(item, index) in ruleForm.SupplierRelatedCompanyList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form_right">
            <el-form-item label="证件号码：" prop="CertificateNo" label-width="150px">
              <el-input v-model="ruleForm.CertificateNo" placeholder="请填写证件号码"></el-input>
            </el-form-item>
            <el-form-item label="身份证地址：" prop="OfficeAddress" label-width="150px">
              <el-input v-model="ruleForm.OfficeAddress" placeholder="身份证地址"></el-input>
            </el-form-item>
            <el-form-item label="推荐人：" label-width="150px" prop="Referrer">
              <div style="width: 100%">
                <div style="padding-bottom: 10px">
                  <el-input placeholder="请输入推荐人手机" class="width_full1" v-model="ReferrerName"></el-input>
                  <el-button style="margin-left: 10px" type="primary" @click="querySearchAsync()">查找</el-button>
                </div>
                已选推荐人:
                <div class="name_wrap name_wrap2" v-if="ruleForm.Referrer != 0">
                  <span>{{ ruleForm.ReferrerName }}|{{ ruleForm.ReferrerMobile }}</span>
                  <i style="cursor: pointer" @click="deleteReferrerName()" class="el-icon-delete"></i>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="line"></div>
    </div>
    <div class="form_wrap">
      <span class="title">联系信息</span>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm2">
          <div class="form_left">
            <el-form-item label="联系电话：" prop="Mobile" label-width="150px">
              <el-input v-model="ruleForm.Mobile" placeholder="请填写联系电话"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱：" prop="Email" label-width="150px">
              <el-input v-model="ruleForm.Email" placeholder="请填写电子邮箱"></el-input>
            </el-form-item>
          </div>
          <div class="form_right">
            <el-form-item label="现居住地址：" prop="ContactAddress" label-width="150px">
              <el-input v-model="ruleForm.ContactAddress" placeholder="请填写现居住地址"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="line"></div>
    </div>
    <div class="form_wrap">
      <span class="title">银行收款信息</span>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm3">
          <div class="form_left">
            <el-form-item label="开户名称：" prop="BankAccountName" label-width="150px">
              <el-input v-model="ruleForm.BankAccountName" placeholder="请填写开户名称"></el-input>
            </el-form-item>

            <el-form-item label="开户银行名称：" prop="Bank" label-width="150px">
              <el-input v-model="ruleForm.Bank" placeholder="请填写开户银行名称"></el-input>
            </el-form-item>
          </div>
          <div class="form_right">
            <el-form-item label="开户银行账户：" prop="BankAccount" label-width="150px">
              <el-input v-model="ruleForm.BankAccount" placeholder="请填写开户银行账户"></el-input>
            </el-form-item>
            <!-- <el-form-item label="联行号：" prop="BankApprovalNumber" label-width="150px">
              <el-input v-model="ruleForm.BankApprovalNumber" placeholder="请填写联行号"></el-input>
            </el-form-item> -->
          </div>
        </el-form>
      </div>
      <div class="line"></div>
    </div>
    <MsgForm :FileList.sync="FileList2" v-if="FileList2.length" ref="MsgForm" />
    <SupplierType
      :tableData="ruleForm.SupplierTypeTree"
      :tableData1="ruleForm.SupplierTypeList"
      :dialogvisible.sync="dialogvisible"
      :selectSupplierType.sync="selectSupplierType"
    ></SupplierType>
    <div class="btn_wrap" v-if="isEdit">
      <span class="btn_1" @click="submit(false)">保存草稿</span>
      <span class="btn_1" @click="submit(true)">提交申请</span>
    </div>
  </div>
</template>

<script>
import MsgForm from '@/components/common/MsgForm'
import SupplierType from '@/components/common/SupplierType'
import { validateEmail, validatemobile1, validateIdCard, validateIdCard1, validContact } from '@/assets/js/util'
export default {
  components: {
    MsgForm,
    SupplierType
  },
  props: {
    parentForm: Object
  },
  data() {
    return {
      selectSupplierType: [],
      dialogvisible: false,
      isSubmit: false,
      treeprops: {
        label: 'name',
        Child: 'children'
      },
      value: '',
      isEdit: false,
      ruleForm: {
        SupplierTypeList: []
      },
      FileList2: [],
      userList: [],
      ReferrerName: '',
      rules: {
        Sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        Contact: [{ required: true, validator: validContact, trigger: 'blur' }],
        SupplierType: [{ required: true, message: '请选择供应商类型', trigger: 'blur' }],
        CertificateType: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        ReferrerName: [{ required: true, message: '请输入推荐人', trigger: 'blur' }],
        CertificateNo: [{ required: true, message: '', trigger: 'blur' }],
        ContactAddress: [{ required: true, message: '请输入联系地址', trigger: 'blur' }],
        Bank: [{ required: true, message: '请输入开户银行名称', trigger: 'blur' }],
        BankAccount: [{ required: true, message: '请输入开户银行账户', trigger: 'blur' }],
        SupplierOtherType: [{ required: true, message: '请输入其他供应商类型', trigger: 'blur' }],
        ProductSource: [{ required: true, message: '请选择产品来源', trigger: 'blur' }],
        OfficeAddress: [{ required: true, message: '请输入身份证地址', trigger: 'blur' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        Mobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        BankAccountName: [{ required: true, message: '请填写开户名称', trigger: 'blur' }],
        SupplierRelatedCompany: [{ required: true, message: '请选择关联公司', trigger: 'blur' }]
      },
      isSupplierOtherType: false,
      certificateNo: '',
      ReferrerNameVaildate: false
    }
  },
  computed: {
    CertificateType() {
      return this.ruleForm.CertificateType
    },
    CertificateNo() {
      return this.ruleForm.CertificateNo
    }
    // ReferrerName() {
    //   return this.ruleForm.ReferrerName
    // }
  },
  watch: {
    // ReferrerName(newVal) {
    //   const reg = /^1[3-9]{1}[0-9]{9}$/
    //   if (reg.test(newVal)) {
    //     this.ruleForm.Referrer = 0
    //   }
    // },
    CertificateType(newVal, oldVal) {
      if (newVal == 1) {
        //身份证验证
        if (this.certificateNo == this.ruleForm.CertificateNo && this.certificateNo != '') {
          delete this.rules.CertificateNo[0].validator
        } else {
          this.rules.CertificateNo[0].validator = validateIdCard
        }
      } else {
        if (this.certificateNo == this.ruleForm.CertificateNo && this.certificateNo != '') {
          delete this.rules.CertificateNo[0].validator
        } else {
          this.rules.CertificateNo[0].validator = validateIdCard1
        }
      }
    },
    CertificateNo(newVal, oldVal) {
      if (newVal == this.certificateNo && this.certificateNo != '') {
        delete this.rules.CertificateNo[0].validator
      } else {
        if (this.ruleForm.CertificateType == 1) {
          delete this.rules.CertificateNo[0].validator
          this.rules.CertificateNo[0].validator = validateIdCard
        } else {
          delete this.rules.CertificateNo[0].validator
          this.rules.CertificateNo[0].validator = validateIdCard1
        }
      }
    },
    selectSupplierType(newVal, oldVal) {
      this.ruleForm.SupplierTypeName = []
      this.ruleForm.SupplierType = []
      newVal.forEach((item) => {
        this.ruleForm.SupplierTypeName.push(item.firstName + '-' + item.secondName + '-' + item.supplierTypeName)
        this.ruleForm.SupplierType.push(item.paramItemCode)
      })
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    back() {
      this.$router.push('/')
    },
    getList() {
      let loginName
      if (this.$route.query.loginName) {
        loginName = this.$route.query.loginName
        this.isEdit = true
      } else {
        loginName = this.parentForm.enloginName
      }
      this.postRequest('SupplierLogin/BaseDataEdit', {
        loginName: loginName
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.userList = res.data.data.UserList
            this.ruleForm = res.data.data
            this.FileList2 = this.ruleForm.FileList2
            this.certificateNo = this.ruleForm.CertificateNo
            if (this.ruleForm.SupplierOtherType == '' || this.ruleForm.SupplierOtherType == null) {
              this.isSupplierOtherType = false
            } else {
              this.isSupplierOtherType = true
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleChange() {
      //供应商
      if (this.ruleForm.SupplierType.includes(0)) {
        this.isSupplierOtherType = true
      } else {
        this.isSupplierOtherType = false
      }
    },
    CertificateTypeFn(val) {
      if (val) {
        this.$refs['CertificateType'].clearValidate()
      }
    },
    focusError() {
      setTimeout(() => {
        const isError = document.getElementsByClassName('is-error')
        isError[0].querySelector('input').focus()
      }, 100)
    },
    validateSupplierType() {
      var issumit = true
      if (this.ruleForm.SupplierType.length == 0) {
        this.$message.error('请选择供应商类型')
        return false
      }
      if (this.ruleForm.Referrer == 0) {
        this.$message.error('请填写推荐人')
        return false
      }
      // let arr = this.$refs.treerefs.getCheckedKeys();
      // let arr1 = this.$refs.treerefs.getCheckedNodes();
      // if (arr.length == 0) {
      //   this.$message.error("请选择供应商类型");
      //   return false;
      // }
      // arr1.forEach(item => {
      //   if (item.other && issumit) {
      //     if (!document.getElementById(item.id).value) {
      //       this.$message.error("请输入其他供应商类型");
      //       issumit = false;
      //     } else {
      //       item.othervalue = document.getElementById(item.id).value;
      //     }
      //   }
      // });
      // this.ruleForm.SupplierType = JSON.stringify(arr1);
      return issumit
    },
    formRule() {
      var flag = this.validateSupplierType()
      if (flag) {
        return new Promise((resolve, reject) => {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.$refs.ruleForm2.validate((valid1) => {
                if (valid1) {
                  this.$refs.ruleForm3.validate((valid2) => {
                    if (valid2) {
                      resolve(true)
                    } else {
                      this.focusError()
                      resolve(false)
                    }
                  })
                } else {
                  this.focusError()
                  resolve(false)
                }
              })
            } else {
              this.focusError()
              resolve(false)
            }
          })
        })
      } else {
        resolve(false)
      }
    },
    async submit(submit) {
      if (submit) {
        let isSubmit = await this.formRule()
        this.$refs.MsgForm.ruleList()
        if (this.$refs.MsgForm.iserror && isSubmit) {
          this.postRequest('SupplierLogin/BaseDataSave', {
            fileListJson: JSON.stringify(this.$refs.MsgForm.list),
            baseDataJson: JSON.stringify(this.ruleForm),
            isSubmit: submit
          })
            .then((res) => {
              if (res.data.errcode == 0) {
                this.$router.push({
                  //传外键值到审核进度详细页面
                  path: '/SuccessApply',
                  query: { name: '注册流程信息' }
                })
              } else {
                this.$message.error(res.data.errmsg)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      } else {
        this.$refs.MsgForm.ruleList1()
        this.postRequest('SupplierLogin/BaseDataSave', {
          fileListJson: JSON.stringify(this.$refs.MsgForm.list),
          baseDataJson: JSON.stringify(this.ruleForm),
          isSubmit: submit
        })
          .then((res) => {
            if (res.data.errcode == 0) {
              this.$router.push({
                //传外键值到审核进度详细页面
                path: '/personal',
                query: { loginName: res.data.loginName }
              })
            } else {
              this.$message.error(res.data.errmsg)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    renderContent(h, { node, data, store }) {
      if (data.other) {
        return (
          <span class="custom-tree-node">
            <span> {node.label} </span>{' '}
            <input id={data.id} value={data.othervalue} style="height:26px;line-height:26px;margin-left:5px" class="el-input__inner otherinput" />{' '}
          </span>
        )
      } else {
        return (
          <span class="custom-tree-node">
            <span> {node.label} </span>{' '}
          </span>
        )
      }
    },
    querySearchAsync(queryString, cb) {
      var users = this.ruleForm.UserList
      const reg = /^1[3-9]{1}[0-9]{9}$/
      var results = queryString
        ? users.filter((item) => {
            return item.Mobile1 == queryString
          })
        : users
      if (!reg.test(queryString)) {
        this.$message.error('请输入正确的手机号！')
        this.ruleForm.Referrer = 0
      }
      if (reg.test(queryString) && results.length == 0) {
        this.$message.error('供应商入库推荐人的手机号码默认为我司员工在我司系统报备号码，现查无此人，请联系我司对接人员！')
      }

      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // createFilter(queryString) {
    //   return user => {
    //     return (
    //       String(user.Mobile1)===queryString
    //     );
    //   };
    // },

    openSupplierTypePage() {
      this.dialogvisible = true
    },
    querySearchAsync() {
      var users = this.ruleForm.UserList
      const reg = /^1[3-9]{1}[0-9]{9}$/
      var results = this.ReferrerName
        ? users.filter((item) => {
            return item.Mobile1 == this.ReferrerName
          })
        : []
      if (!reg.test(this.ReferrerName)) {
        this.$message.error('请输入正确的推荐人手机号！')
        this.ruleForm.Referrer = 0
      }
      if (reg.test(this.ReferrerName) && results.length == 0) {
        this.$message.error('供应商入库推荐人的手机号码默认为我司员工在我司系统报备号码，现查无此人，请联系我司对接人员！')
        this.ruleForm.Referrer = 0
      }
      if (results.length > 0) {
        this.ruleForm.Referrer = results[0].UserId
        this.ruleForm.ReferrerName = results[0].UserName
        this.ruleForm.ReferrerMobile = results[0].Mobile1
      }
    },
    handleSelect(item) {
      this.ruleForm.Referrer = item.UserId
      this.ruleForm.ReferrerName = item.UserName
      this.ruleForm.ReferrerMobile = item.Mobile1
    },
    deleteReferrerName() {
      this.ruleForm.Referrer = 0
      this.ruleForm.ReferrerName = ''
      this.ruleForm.ReferrerMobile = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.supplierOtherType {
  display: inline-block;
  margin: 0 0 0 10px;

  ::v-deep .el-form-item__content {
    .el-form-item__error {
      top: 105% !important;
    }
  }
}

.btn_wrap {
  width: 500px;
  margin: 30px auto 50px;

  .btn_1 {
    font-weight: bold;
    margin: 0 30px;
  }

  .btn {
    color: #fff;
    background: #2db7f5;
  }
}

.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}

.tree {
  width: 400px;
  background: transparent !important;
}

.width_full {
  width: 100% !important;
}
.width_full1 {
  width: 80% !important;
}
.name_wrap {
  border: 1px solid #606266;
  margin-left: 11px;
  border-radius: 10px;
  padding: 0 4px;
}

.name_wrap2 {
  display: inline-block;
  padding: 5px;
}
</style>